import React from "react"

type AssetCaptionProps = { caption: string }

export default function AssetCaption({ caption }: AssetCaptionProps) {
  return <p className="bg-default/5 px-4 py-2 text-center text-sm">{caption}</p>
}
